import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home';

export default function UserAccountPage() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}